<style lang="scss">
  @use "../../../../assets/css/design-system/colors";
  @use "../../../../assets/css/design-system/utils";
</style>

<script>
  import Modal from "../../Modal/Modal.svelte";
  import DatePickerBody from "../DatePicker/DatePickerBody.svelte";

  let { onclose = () => {}, blur = "4px" } = $props();
</script>

<Modal
  {blur}
  closeButton={false}
  showHeader={false}
  {onclose}
  modalBodyStyle="width: calc(min(90vw, 18.75rem)); height: calc(min(90vh, 27.875rem))"
>
  <DatePickerBody />
</Modal>
